import axios from "./axios-handler.service";
const BASE_URL = "/api/Consultores";

export interface Consultor {
  idConsultor: number;
  nome: string;
  cpf: number;
  email: string;
  telefone: number;
  celular: number;
  versao: number;
  dataCadastro: string;
  dataUltimoLogin: string;
  statusCadastro: boolean;
  motivoInatividade: string;
  dataMigracao: string;
  statusAssinatura: boolean;
  listaCatalogos: Catalogo[];
  observacao: string;
}
export interface Assinatura {
  idAssinatura: number;
  ativo: boolean;
  meioPagamento: number;
  dataCadastro: string;
  dataCancelamento: string;
  motivoCancelamento: string;
  tipoPlano: Plano;
  parcelas: number;
}
export interface Catalogo {
  idCatalogo: string;
  idFornecedor: string;
  nome: string;
  descricao: string;
  tipo: string;
  ativo: boolean;
  dataCriacao: string;
}

export interface Preferencia {
  receberLembretes: boolean;
  receberNotificacaoIndicaco: boolean;
  receberNovidades: boolean;
  receberWhatsapp: boolean;
}

export interface EnvioEmails {
  compromissos: boolean;
  novidades: boolean;
  indicacoes: boolean;
  whatsapp: boolean;
}

export interface GerarBoletos {
  plano: string;
  data: string;
}

export interface ExtenderPlano {
  idConsultor: number;
  tipoPlano: TipoPlano;
  quantidadeDias: number;
  observacao: string;
}

export interface TipoAtendimento {
  descricao: string;
  idTipoAtendimento: IdTipoAtendimento;
}

export interface Transacao {
  date: string;
  lastEventDate: string;
  transactionDescription: string;
}

export enum TipoPlano {
  Gratis = "Gratis",
  MensalLite = "MensalLite",
  TrimestralLite = "TrimestralLite",
  SemestralLite = "SemestralLite",
  AnualLite = "AnualLite",
  BonusLite = "BonusLite",
  Mensal = "Mensal",
  Trimestral = "Trimestral",
  Semestral = "Semestral",
  Anual = "Anual",
  Bonus = "Bonus",
  MensalEssencialConectada = "MensalEssencialConectada",
  TrimestralEssencialConectada = "TrimestralEssencialConectada",
  SemestralEssencialConectada = "SemestralEssencialConectada",
  AnualEssencialConectada = "AnualEssencialConectada",
  BonusEssencialConectada = "BonusEssencialConectada",
  MensalSuperConectada = "MensalSuperConectada",
  TrimestralSuperConectada = "TrimestralSuperConectada",
  SemestralSuperConectada = "SemestralSuperConectada",
  AnualSuperConectada = "AnualSuperConectada",
  BonusSuperConectada = "BonusSuperConectada",
  MensalHiperConectada = "MensalHiperConectada",
  TrimestralHiperConectada = "TrimestralHiperConectada",
  SemestralHiperConectada = "SemestralHiperConectada",
  AnualHiperConectada = "AnualHiperConectada",
  BonusHiperConectada = "BonusHiperConectada",
}

export enum IdTipoAtendimento {
  SuporteSistema = 1,
  Treinamento = 2,
  PossivelCliente = 3,
  PlanoExpirado = 4,
  PlanoGratis10Dias = 5,
  FidelizarCliente = 6,
  Outros = 99,
}
export interface Plano {
  idTipoPlano: string;
  ativo: string;
  nome: string;
}

export interface PlanoDto {
  idPlano: number | null;
  dataInicio: string | null;
  dataExpiracao: string | null;
  dataContratacao: string | null;
  valor: number;
  desconto: number | null;
  status: number | null;
  descricaoStatus: string;
  utmCampaign: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmContent: string | null;
  idTipoPlano: number | null;
  tipoPlanoDescricao: string | null;
  descricao: string | null;
  idUsuarioVendedor: number | null;
  nomeVendedor: string | null;
  pontosBonificacao: number | null;
  codCupom: string | null;
  idCupom: string | null;
}

export interface AssociarVendedorRequest {
  idPlano: number;
  idVendedor: number;
}

export interface StatusConsultor {
  ativo: boolean | null;
  motivoInatividade: string;
}

export interface FiltroLogAcesso {
  idConsultor: number;
  dataInicio: string;
  dataFim: string;
  offset: number;
  limit: number;
  order?: string;
}

export interface FiltroEnviosAutomaticos {
  idConsultor: number;
  periodo?: {
    dataInicio: string;
    dataFim: string;
  } | null;
  txtPesquisa?: string;
  formattedValueInicio?: string;
  formattedValueFim?: string;
  offset?: number;
  limit?: number;
  order?: string;
}

export interface CobrancaPixRetorno {
  idPlano: number;
  idTipoPlano: number;
  codigo: string;
  instrucao: string;
  qrCodeImagem: string;
  qrCodeTexto: string;
}

export interface FiltroPesquisa {
  query?: string;
  offset: number;
  limit: number;
  order?: string;
}

export interface GerarLinkResponse {
  url: string;
}

export class ConsultoresService {
  static async Pesquisar(filtro: FiltroPesquisa): Promise<any> {
    const { query, offset, limit, order } = filtro;
    const response = await axios.get(`${BASE_URL}/Pesquisar`, {
      params: { query, offset, limit, order },
    });
    return response.data;
  }

  static async ObterDadosConsultor(idConsultor: number): Promise<Consultor> {
    const response = await axios.get<Consultor>(
      `${BASE_URL}/ObterDadosConsultor`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async ListarDadosAssinatura(
    idConsultor: number | null,
  ): Promise<Assinatura> {
    const response = await axios.get<Assinatura>(
      `${BASE_URL}/ListarDadosAssinatura`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async ListarDadosCatalogo(
    idConsultor: number | null,
  ): Promise<Assinatura> {
    const response = await axios.get<Assinatura>(
      `${BASE_URL}/ListarDadosCatalogo`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async ListarPlanosDto(
    idConsultor: number | null,
  ): Promise<PlanoDto[]> {
    const response = await axios.get<PlanoDto[]>(
      `${BASE_URL}/ListarPlanosDto`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async ListarPlanos(
    idConsultor: number | null,
    limit: number,
  ): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/ListarPlanos`, {
      params: { idConsultor, limit },
    });
    return response.data;
  }

  static async ListarAcessos(
    idConsultor: number | null,
    limit: number,
  ): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/ListarAcessos`, {
      params: { idConsultor, limit },
    });
    return response.data;
  }

  static async ListarAssinaturas(idConsultor: number | null): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/ListarAssinaturas`, {
      params: { idConsultor },
    });
    return response.data;
  }

  static async ListarAtendimentos(
    idConsultor: number | null,
    limit: number,
  ): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/ListarAtendimentos`, {
      params: { idConsultor, limit },
    });
    return response.data;
  }

  static async GerarLinkCobranca(
    idConsultor: number,
    idTipoPlano: TipoPlano,
  ): Promise<GerarLinkResponse> {
    const response = await axios.get<GerarLinkResponse>(
      BASE_URL + "/GerarUrlPagamento",
      {
        params: { idConsultor, idTipoPlano },
      },
    );
    return response.data;
  }

  static async LimpezaBase(
    idConsultor: number,
    manterClientes: boolean | null,
  ): Promise<any> {
    let msg = null;
    await axios
      .post(BASE_URL + "/LimpezaBase", {
        idConsultor,
        manterClientes,
      })
      .then((response) => {
        msg = response;
      });
    return msg;
  }

  static async ZerarEstoque(idConsultor: number): Promise<any> {
    let msg = null;
    await axios
      .post(BASE_URL + "/ZerarEstoque", { idConsultor })
      .then((response) => {
        msg = response;
      });
    return msg;
  }

  static async ConfiguraEnvioEmails(
    idConsultor: number,
    envioEmail: EnvioEmails,
  ): Promise<boolean> {
    const { compromissos, novidades, indicacoes, whatsapp } = envioEmail;
    const response = await axios.post(BASE_URL + "/ConfiguraEnvioEmails", {
      idConsultor,
      compromissos,
      novidades,
      indicacoes,
      whatsapp,
    });
    return response.data;
  }

  static async Tickets(email: string): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/Tickets`, {
      params: { email },
    });
    return response.data;
  }

  static async ExtenderPlano(extenderPlano: ExtenderPlano): Promise<boolean> {
    const { idConsultor, tipoPlano, quantidadeDias, observacao } =
      extenderPlano;
    const response = await axios.post(BASE_URL + "/ExtenderPlano", {
      idConsultor,
      quantidadeDias,
      tipoPlano,
      observacao,
    });
    return response.data;
  }

  static async AssociarVendedor(
    request: AssociarVendedorRequest,
  ): Promise<void> {
    const { idPlano, idVendedor } = request;
    await axios.post(`${BASE_URL}/AssociarVendedor`, {
      idPlano,
      idVendedor,
    });
  }

  static async ObterPreferencia(
    idConsultor: number | null,
  ): Promise<Preferencia> {
    const response = await axios.get<Preferencia>(
      `${BASE_URL}/ObterPreferencia`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async AlterarSenha(
    idConsultor: number,
    novaSenha: string,
  ): Promise<boolean> {
    const response = await axios.post(BASE_URL + "/AlterarSenha", {
      idConsultor,
      novaSenha,
    });
    return response.data;
  }

  static async ObterStatusConsultor(
    idConsultor: number | null,
  ): Promise<StatusConsultor> {
    const response = await axios.get<StatusConsultor>(
      `${BASE_URL}/ObterStatusConsultor`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async AtivarInativar(
    idConsultor: number,
    motivo: string | null,
  ): Promise<boolean> {
    const response = await axios.post(BASE_URL + "/AtivarInativar", {
      idConsultor,
      motivo,
    });
    return response.data;
  }

  static async AtivarInativarBetaTester(idConsultor: number): Promise<boolean> {
    const response = await axios.post(BASE_URL + "/AtivarInativarBetaTester", {
      idConsultor,
    });
    return response.data;
  }

  static async ObterEmailConsultor(
    idConsultor: number | null,
  ): Promise<string> {
    const response = await axios.get<string>(
      `${BASE_URL}/ObterEmailConsultor`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async AlterarEmail(
    idConsultor: number,
    email: string,
  ): Promise<boolean> {
    const response = await axios.post(BASE_URL + "/AlterarEmail", {
      idConsultor,
      email,
    });
    return response.data;
  }

  static async ObterDataUtilizacaoAplicativo(
    idConsultor: number | null,
  ): Promise<string> {
    const response = await axios.get<string>(
      `${BASE_URL}/ObterDataUtilizacaoAplicativo`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async AlterarDataUtilizaAplicativo(
    idConsultor: number,
    dataUtilizaAplicativo: string,
  ): Promise<boolean> {
    const response = await axios.post(
      BASE_URL + "/AlterarDataUtilizaAplicativo",
      {
        idConsultor,
        dataUtilizaAplicativo,
      },
    );
    return response.data;
  }

  static async ObterVersaoConsultor(idConsultor: number): Promise<number> {
    const response = await axios.get<number>(
      `${BASE_URL}/ObterVersaoConsultor`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async VoltarParaV1(idConsultor: number): Promise<void> {
    await axios.post(BASE_URL + "/VoltarParaV1", {
      idConsultor,
    });
  }

  static async MigrarParaV2(idConsultor: number): Promise<void> {
    await axios.post(BASE_URL + "/MigrarParaV2", {
      idConsultor,
    });
  }

  static async ConsultarMigracao(idConsultor: number): Promise<string> {
    const response = await axios.get<string>(`${BASE_URL}/ConsultarMigracao`, {
      params: { idConsultor },
    });
    return response.data;
  }

  static async ListaLogAcesso(filtroLogAcesso: FiltroLogAcesso): Promise<any> {
    const { idConsultor, dataInicio, dataFim, offset, limit, order } =
      filtroLogAcesso;
    const response = await axios.get<any>(`${BASE_URL}/ListaLogAcesso`, {
      params: {
        idConsultor,
        dataInicio,
        dataFim,
        offset,
        limit,
        order,
      },
    });
    return response.data;
  }

  static async PopAtendimento(
    idConsultor: number,
    idAtendimento: number | null,
  ): Promise<TipoAtendimento[]> {
    const response = await axios.get<TipoAtendimento[]>(
      `${BASE_URL}/PopAtendimento`,
      {
        params: { idConsultor, idAtendimento },
      },
    );
    return response.data;
  }

  static async NovoAtendimento(
    idConsultor: number,
    tipoAtendimento: TipoAtendimento,
    descricao: string,
    data: string,
    hora: string,
  ): Promise<boolean> {
    const response = await axios.post(BASE_URL + "/NovoAtendimento", {
      idConsultor,
      tipoAtendimento,
      descricao,
      data,
      hora,
    });
    return response.data;
  }

  static async AcessarPainel(idConsultor: number): Promise<any> {
    const response = await axios.post(BASE_URL + "/AcessarPainel", {
      idConsultor,
    });
    return response.data;
  }

  static async StatusPlano(idPlano: number): Promise<any> {
    const response = await axios.get<any>(`${BASE_URL}/StatusPlano`, {
      params: { idPlano },
    });
    return response.data;
  }

  static async CancelarCielo(idTransacao: number, motivo: string) {
    await axios.post(BASE_URL + "/CancelarCielo", {
      idTransacao,
      motivo,
    });
  }

  static async CancelarInter(idTransacao: number, motivo: string) {
    await axios.post(BASE_URL + "/CancelarInter", {
      idTransacao,
      motivo,
    });
  }

  static async SimularPagamentoInter(idTransacao: any) {
    const response = await axios.post(
      `${BASE_URL}/SimularPagamentoInter`,
      null,
      {
        params: {
          idTransacao,
        },
      },
    );
    return response.data;
  }

  static async CancelarPlano(
    idConsultor: number,
    idPlano: number,
    motivo: string,
  ) {
    await axios.post(BASE_URL + "/CancelarPlano", {
      idConsultor,
      idPlano,
      motivo,
    });
  }

  static async ConsultarTransacao(idTransacao: string): Promise<any> {
    let erro = false;
    const response = await axios
      .post<any>(`${BASE_URL}/ConsultarTransacao`, { idTransacao })
      .catch((error) => {
        erro = true;
        return error;
      });
    if (erro) {
      const retorno = {
        resposta: "Ocorreu um problema ao processar a transação do PagSeguro.",
        sucess: false,
      };
      return retorno;
    } else {
      const retorno = {
        resposta: response.data,
        sucess: true,
      };
      return retorno;
    }
  }

  static async ProcessarStatus(idTransacao: string): Promise<any> {
    const response = await axios
      .post<any>(`${BASE_URL}/ProcessarStatus`, { idTransacao })
      .catch((error) => {
        return error;
      });
    return response.data;
  }

  static async ObterFreshdesk(): Promise<string> {
    const response = await axios.get<string>(`${BASE_URL}/ObterFreshdesk`);
    return response.data;
  }

  static async AlterarNumeroContato(
    idConsultor: number,
    numero: string,
    tipoNumeroTelefone: number,
  ) {
    await axios.post(BASE_URL + "/AlterarNumeroContato", {
      idConsultor,
      numero,
      tipoNumeroTelefone,
    });
  }

  static async ObterStatusBetaLojaConsultor(
    idConsultor: number | null,
  ): Promise<boolean> {
    const response = await axios.get<boolean>(
      `${BASE_URL}/ObterStatusBetaLojaConsultor`,
      {
        params: { idConsultor },
      },
    );
    return response.data;
  }

  static async AtivarInativarBetaLojaConsultor(
    idConsultor: number,
  ): Promise<boolean> {
    const response = await axios.post(
      BASE_URL + "/AtivarInativarBetaLojaConsultor",
      {
        idConsultor,
      },
    );
    return response.data;
  }

  static async EditarObservacao(
    idConsultor: number,
    observacao: string | null,
  ) {
    await axios.post(BASE_URL + "/EditarObservacao", {
      idConsultor,
      observacao,
    });
  }

  static async PesquisarEnviosAutomaticos(
    filtros: FiltroEnviosAutomaticos,
  ): Promise<any> {
    const { idConsultor, txtPesquisa, offset, limit, order } = filtros;
    const response = await axios.get<any>(
      `${BASE_URL}/PesquisarEnviosAutomaticos`,
      {
        params: {
          idConsultor,
          txtPesquisa: txtPesquisa ?? "",
          offset,
          limit,
          order,
        },
      },
    );
    return response.data;
  }
}
